import { useEffect, useRef, useState, useCallback } from "react";

// Hodnota, která se propíše až `ms` po poslední změně (219: hledání v Docházce
// nepošle request na každé písmeno). Prázdná hodnota se propíše hned — smazání
// hledání má seznam vrátit bez čekání.
export function useDebouncedValue(value, ms = 350) {
  const [v, setV] = useState(value);
  useEffect(() => {
    if (value === "" || value == null) { setV(value); return undefined; }
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}

// Jen poslední odpověď smí do stavu (219): starší request, který se vrátí později
// než novější, se zahodí. begin() vrací funkci „jsem pořád poslední?“.
export function useLatestOnly() {
  const seq = useRef(0);
  return useCallback(() => {
    const id = ++seq.current;
    return () => id === seq.current;
  }, []);
}
